import React, { useEffect, useState } from "react";
import { Search, MapPin } from "lucide-react";
import { get, todayISO } from "./techData";
import { Screen, Card } from "./ui";

export default function ClientsScreen({ nav, tabs }) {
  const [q, setQ] = useState(""), [rows, setRows] = useState([]), [err, setErr] = useState("");
  useEffect(() => {
    if (q.trim().length < 2) { setRows([]); return undefined; }
    const t = setTimeout(() => get(`/tech/clients?q=${encodeURIComponent(q.trim())}`).then((r) => { setRows(r); setErr(""); }).catch((e) => setErr(e.message)), 300);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <Screen title="Clients" testid="tech-clients" right={tabs}>
      <div className="relative">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-7 w-7 text-slate-400" />
        <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Name, street or phone" data-testid="tech-clients-search" className="w-full h-16 rounded-2xl border-2 border-slate-200 pl-14 pr-4 text-[19px] font-bold outline-none focus:border-cyan-500" />
      </div>
      {err && <Card className="text-red-700 font-bold">{err}</Card>}
      {rows.map((c) => (
        <button key={c.id} onClick={() => nav.go("stop", { clientId: c.id, date: todayISO() })} data-testid={`tech-client-${c.id}`} className="w-full text-left bg-white rounded-2xl p-4 shadow-sm active:scale-[0.99]">
          <div className="text-[19px] font-black text-slate-900">{c.name}</div>
          <div className="text-[15px] text-slate-600 flex items-center gap-1"><MapPin className="h-4 w-4" />{c.address || "No address"}</div>
        </button>
      ))}
      {q.trim().length >= 2 && !rows.length && !err && <Card className="text-center text-slate-500">No clients found.</Card>}
    </Screen>
  );
}
